import React from 'react'

const CustomerWiseDieReport = () => {
  return (
    <div>CustomerWiseDieReport</div>
  )
}

export default CustomerWiseDieReport